/* eslint-disable react/prop-types */
import React, { useRef, useState, useEffect } from 'react'
import { useHistory, useLocation } from 'react-router-dom'
import styled from 'styled-components'
import Checkbox from '@material-ui/core/Checkbox'
import { XDivider, YDivider, FlexByRowCentered } from 'irmlib/styles'
import { Label, ThemeButton, OutlinedButton, ContainedButton } from 'irmlib/components/Controls'
import { CancelButton, TextField } from 'irmlib/components/FormControls'
import * as gdeTransactions from '../../../services/firestore/gdeTransactions'
import { LocalToast, setBusy, clearBusy, openGeneralDialog, closeGeneralDialog } from 'irmlib/containers'
import PropTypes from 'prop-types'
import cloneDeep from 'clone-deep'
import { successToast, errorToast } from '../../../common/functions'
import { useFormPageHandler, useConstructor } from 'irmlib/hooks'
import * as constants from 'irmlib/common/constants'
import { userTypes } from '../../../common/constants'
import * as routePaths from '../../../navigation/routePaths'
import { DataGrid, GridToolbarContainer, GridToolbarColumnsButton } from '@mui/x-data-grid'
import { useTranslation } from 'react-i18next'


const SKPBOX = 0
const DIV = 1
const DEPT = 2

const modalFormTemplate = [
  {
    label: 'dataEntry.skpBoxID',
    fieldKey: 'obj.obj1.skpId',
  },
  {
    label: 'dataEntry.divisionID',
    fieldKey: 'obj.obj1.divisionId',
  },
  {
    label: 'dataEntry.departmentID',
    fieldKey: 'obj.obj1.departmentId',
  }
]

const BoxFlex = styled('div')`
  display: flex;
  float: right;
  margin: -16px;
`
const BoxSet = styled('div')`
  display: flex;
`
const BoxSetContainer = styled('div')`
  width: 100%;
`

const BoxTextfield = styled('div')`
  width: 100%;
`

const BottomPaddedDiv = styled('div')`
  padding-bottom: 20px;
`

const TableContainer = styled(BottomPaddedDiv)`
  max-height: 700px;
`

const VerticalDivider = () => <YDivider height="30px" />

const BottomPaddedButton = (props) => (
  <>
    <ThemeButton {...props} />
    <VerticalDivider />
  </>
)

const CountStyle = styled('div')`
  margin-top: -36px;
  font-size: 16px;
  height: 0px;
  color: #1b75bc;
`

const DivWrap = styled('div')`
  display: flex;
  justify-content: center;
  width: 100%;
`

const DivCenter = styled('div')`
  display: flex;
  justify-content: center;
  white-space: nowrap;
  width: 100%;
  margin-bottom: -8px;
`
const DivWarning = styled('div')`
  display: flex;
  justify-content: center;
  white-space: nowrap;
  width: 100%;
`

const DatGridTable = (props) => {
  const { t } = useTranslation()
  // const [state, setState, getState] = useMergeState()
  const history = useHistory()
  const { columnsList, isViewAllFiles, currentTemplateType, apiRef, qualityCheck, currentUserType, dataEntryType } = props
  let { indexPointerOfFile } = props
  const [enable, setEnable] = useState(true)
  const [selectedFiles, setSelectedFiles] = useState([])
  const refLocalBusyCursor = useRef(null)


  const [filesLength, setFilesLength] = useState()
  const refFileList = useRef(null)
  const [fileList, setFileList] = useState([])
  const location = useLocation()
  const pathParams = location.pathname.split('/')
  const isBoxList = pathParams[1]

  const formTemplate = [
    {
      label: 'dataEntry.skpBoxID',
      fieldKey: 'obj.obj1.skpId',
    },
    {
      label: 'dataEntry.divisionID',
      fieldKey: 'obj.obj1.divisionId',
    },
    {
      label: 'dataEntry.departmentID',
      fieldKey: 'obj.obj1.departmentId',
    }
  ]

  useEffect(() => {
    setFileList(props.fileList)
  }, [props.fileList])

  useConstructor(() => {
    refFileList.current = cloneDeep(props.fileList)
  })

  const refLocalToast = useRef(null)

  const onSelectionChange = (rows) => {
    if (rows?.length > 0 && !isViewAllFiles) {
      setEnable(false)
    } else {
      setEnable(true)
    }
    const selectedRowdata = []
    const checkedRows = apiRef.current.getSelectedRows()
    checkedRows.forEach((value) => {
      selectedRowdata.push(value)
    })
    setSelectedFiles(selectedRowdata)
    setFilesLength(rows.length)
  }

  const ModalContent = (props) => {
    const { selectedFiles } = props
    const [enableSKPField, setEnableSKPFields] = useState(true)
    const [enableACC2Field, setEnableACC2Fields] = useState(true)
    const [enableACC3Field, setEnableACC3Fields] = useState(true)
    const [isUpdateDisabled, setIsUpdateDisabled] = useState(true)

    const [postObject, setPostObject] = useState({
      newBoxId: '',
      divId: '',
      deptId: '',
      targetBoxData: {}
    })
    const skpRef = useRef(null)
    const divRef = useRef(null)
    const deptRef = useRef(null)
    const skpBoxValue = async (e) => {
      if (e.keyCode === 13) {
        if (e.target.value !== '') {
          validateSkpBoxValue(e)
        }
      }
    }
    const onBlurskpBoxValue = async (e) => {
      if (e.target.value !== '') {
        validateSkpBoxValue(e)
      }
    }

    const validateSkpBoxValue = async (e) => {
      setBusy()
      const boxes = await gdeTransactions.getBox(props.jobId, e.target.value)
      // eslint-disable-next-line eqeqeq
      if (props.boxId === e.target.value) {
        skpRef?.current?.setErrorMsg(t('messages.sameErr'), true)
      } else if (!boxes.exists()) {
        skpRef?.current?.setErrorMsg(t('messages.notExist'), true)
        setIsUpdateDisabled(true)
      } else if (boxes.data().status === constants.boxStatus.transmitted || boxes.data().status === constants.boxStatus.exception || boxes.data().status === constants.boxStatus.requiresReKey) {
        if (boxes.data().status === constants.boxStatus.transmitted) {
          skpRef?.current?.setErrorMsg(t('messages.boxStatTransmit'), true)
        } else if (boxes.data().status === constants.boxStatus.exception) {
          skpRef?.current?.setErrorMsg(t('messages.boxStatException'), true)
        } else {
          skpRef?.current?.setErrorMsg(t('messages.boxStatRekeying'), true)
        }
        setIsUpdateDisabled(true)
      } else {
        setIsUpdateDisabled(false)
        setPostObject(prevState => ({
          ...prevState,
          newBoxId: e.target.value,
          targetBoxData: boxes.data()
        }))
      }

      clearBusy()
    }
    const onChangeCheckBox = (e) => {
      if (e.target.id === 'dataEntry_SKPBOX') {
        setEnableSKPFields(prevState => !prevState)
        skpRef.current.focus()
      } else if (e.target.id === 'dataEntry_DIV') {
        setEnableACC2Fields(prevState => !prevState)
      } else {
        setEnableACC3Fields(prevState => !prevState)
      }
    }

    const convertToUpperCase = async (e) => {
      const skpBoxValue = e.target.value 
      // eslint-disable-next-line
      return e.target.value = ('' + skpBoxValue).toUpperCase()
    }

    const ButtonForYes = () => {
      const handleNo = () => {
        closeGeneralDialog()
        handleModal()
      }
      return (
        <>
          <BoxSetContainer>
            <FlexByRowCentered>
              <OutlinedButton id={'dataEntry_button_onNoMoreBoxToComplete'} onClick={() => handleNo()} noTranslate={true}>{props.t('buttons.no')}</OutlinedButton>
              <XDivider width='10px' />
              <ContainedButton id={'dataEntry_button_onHaveMoreBoxToComplete'} onClick={() => bulkPostService(selectedFiles, postObject, props.jobId, props.boxId)} noTranslate={true}>{props.t('buttons.yes')}</ContainedButton>
            </FlexByRowCentered>
          </BoxSetContainer>
        </>
      )
    }

    ButtonForYes.propTypes = {
      t: PropTypes.any
    }

    const onClickYes = () => {
      openGeneralDialog({
        // title: '',
        message: <DivWarning><Label>dataEntry.warning1</Label><pre> <CountStyle> {filesLength} </CountStyle></pre><Label>dataEntry.warning2</Label></DivWarning>,
        buttons: <ButtonForYes />,
        closeX: true
      })
    }

    const onCancel = () => {
      closeGeneralDialog()
    }

    const onChangeDiv = (e) => {
      if (e.keyCode === 13) {
        setPostObject(prevState => ({
          ...prevState,
          divId: e.target.value
        }))
      }
    }

    const onChangeDept = (e) => {
      if (e.keyCode === 13) {
        setPostObject(prevState => ({
          ...prevState,
          deptId: e.target.value
        }))
      }
    }

    return (
      <>
        <DivCenter>
          <Label>dataEntry.selectFieldsMsg1</Label>
          <pre> <CountStyle> {filesLength} </CountStyle></pre>
          <Label>dataEntry.selectFieldsMsg2</Label>
        </DivCenter>
        <DivWrap><Label>dataEntry.selectFieldsMsg3</Label></DivWrap>
        <DivWrap><Label>dataEntry.selectFieldsMsg4</Label></DivWrap>
        <BoxSetContainer>
          <YDivider height='30px' />
          <BoxSet>
            <Checkbox
              id={'dataEntry_SKPBOX'}
              onChange={(e) => onChangeCheckBox(e)}
            />
            <BoxTextfield>
              <TextField
                ref={skpRef}
                fieldTemplate={modalFormTemplate[SKPBOX]}
                value={props.boxId}
                disabled={enableSKPField}
                onKeyDown={(e) => skpBoxValue(e)}
                onBlur={(e) => onBlurskpBoxValue(e)}
                onInput={(e) => convertToUpperCase(e)}
              />
            </BoxTextfield>
          </BoxSet>
          <YDivider height='15px' />
          <BoxSet>
            <Checkbox
              id={'dataEntry_DIV'}
              onChange={(e) => onChangeCheckBox(e)}
            />
            <BoxTextfield>
              <TextField
                ref={divRef}
                fieldTemplate={modalFormTemplate[DIV]}
                value={props.accountLevel2}
                disabled={enableACC2Field}
                onKeyDown={(e) => onChangeDiv(e)}
              />
            </BoxTextfield>
          </BoxSet>
          <YDivider height='15px' />
          <BoxSet>
            <Checkbox
              id={'dataEntry_DEPT'}
              onChange={(e) => onChangeCheckBox(e)}
            />
            <BoxTextfield>
              <TextField
                ref={deptRef}
                fieldTemplate={modalFormTemplate[DEPT]}
                value={props.accountLevel3}
                disabled={enableACC3Field}
                onKeyDown={(e) => onChangeDept(e)}
              />
            </BoxTextfield>
          </BoxSet>
          <YDivider height='30px' />
        </BoxSetContainer>
        <BoxSetContainer>
          <FlexByRowCentered>
            <>
              <CancelButton onClick={onCancel} />
              <XDivider width='10px' />
              <ContainedButton disabled={isUpdateDisabled} onClick={() => onClickYes()} >buttons.updateFields</ContainedButton>
            </>
          </FlexByRowCentered>
          <YDivider height='30px' />
        </BoxSetContainer>
      </>
    )
  }

  ModalContent.propTypes = {
    boxId: PropTypes.any,
    accountLevel2: PropTypes.any,
    accountLevel3: PropTypes.any,
    jobId: PropTypes.string,
    selectedFiles: PropTypes.array
  }
  const getService = async () => {
    const getObject = {
    }
    return Promise.resolve(getObject)
  }

  // eslint-disable-next-line
  const [arrRefs] = useFormPageHandler({
    formTemplate,
    service: getService,
    busyOverride: refLocalBusyCursor,
  }
  )

  const bulkPostService = async (selectedFiles, postObject, jobId, oldBoxId) => {
    const { newBoxId, divId, deptId, targetBoxData } = postObject
    // console.log('files', selectedFiles)
    const files = []
    let fileLength = 0

    // Checking current box
    const filesExisting = await gdeTransactions.getFilesForBox(jobId, newBoxId)
    const sourceBoxData = await gdeTransactions.getBox(jobId, oldBoxId)
    if (filesExisting.size > 0) {
      fileLength = parseInt(filesExisting.docs[filesExisting.size - 1].id)
    }

    // eslint-disable-next-line react/prop-types

    const fileListTemp = fileList.filter(item => !selectedFiles.includes(item))
    // eslint-disable-next-line
    selectedFiles.forEach((row, index) => {
      const fileNo = `${fileLength + 1}`
      const fileNumber = fileNo.padStart(5, '0')
      files[fileNumber] = row
      files[fileNumber].oldFileId = files[fileNumber].fileId
      files[fileNumber].fileId = fileNumber
      files[fileNumber].skpBoxId = newBoxId

      if (files[fileNumber].divisionId) {
        files[fileNumber].divisionId = divId !== '' ? divId : row?.divisionId
      }
      if (files[fileNumber].departmentId) {
        files[fileNumber].departmentId = deptId !== '' ? deptId : row?.departmentId
      }

      fileLength++
    })

    let fileCount = 0
    // updating status of box if the box already passed QC 
    if (targetBoxData?.status === constants.boxStatus.approved) {
      if (props.isFromQC) {
        await gdeTransactions.updateBoxData(jobId, newBoxId, { status: constants.boxStatus.readyForQc })
      } else {
        await gdeTransactions.updateBoxData(jobId, newBoxId, { status: props.statusTobeUpdated })
      }
    }

    if (sourceBoxData.data().status === constants.boxStatus.requiresReKey ||
      sourceBoxData.data().status === constants.boxStatus.dataEntryInProcess) {
      fileCount = fileListTemp.length
    } else {
      fileCount = fileListTemp.length - 1
    }
    await gdeTransactions.moveFilesForBox(jobId, oldBoxId, newBoxId, files, targetBoxData)

    // change message
    successToast({ title: t('toast.bulkUpdateTitle') })
    closeGeneralDialog()
    props.onCloseTable(currentUserType, props.tableRef, jobId, oldBoxId, fileCount, true, fileListTemp)
  }

  const handleModal = (boxId, acc2, acc3, arrRefs, buttonRef, selectedFiles, jobId, modalRef) => {
    openGeneralDialog({
      title: <FlexByRowCentered><Label noTranslate={true}>{t('dataEntry.selectFields')}</Label></FlexByRowCentered>,
      message: <ModalContent arrRefs={arrRefs} boxId={boxId} accountLevel2={acc2} accountLevel3={acc3} jobId={jobId} modalRef={modalRef} selectedFiles={selectedFiles} t={t}/>,
      buttons: <></>,
      closeX: true
    })
  }

  const handleDeleteModal = (jobId, boxId, selectedFiles) => {
    if (dataEntryType === 'New File' || dataEntryType === 'Maintenance File') {
      if (filesLength === fileList.length && (currentUserType?.current !== userTypes.DATAENTRY_AND_VERIFY_USER && currentUserType?.current !== userTypes.DATAENTRY_USER)) {
        errorToast({ message: t('toast.restrictDeletionOfAllFiles') })
      } else {
        openGeneralDialog({
          title: <FlexByRowCentered><Label>dataEntry.selectFilesToDelete</Label></FlexByRowCentered>,
          message: t('dataEntry.confirmRecordDelete'),
          buttons: <>
            <CancelButton onClick={onCancel} />
            <XDivider width='10px' />
            <ContainedButton onClick={() => handleDeleteFiles(jobId, boxId, selectedFiles)} >buttons.yes</ContainedButton>
          </>,
          closeX: true
        })
      }
    } else {
      if (filesLength === fileList.length && (currentUserType?.current !== userTypes.DATAENTRY_AND_VERIFY_USER && currentUserType?.current !== userTypes.DATAENTRY_USER)) {
        errorToast({ message: t('toast.restrictDeletionOfAllBoxes') })
      } else {
        openGeneralDialog({
          title: <FlexByRowCentered><Label>dataEntry.selectFilesToDelete</Label></FlexByRowCentered>,
          message: t('dataEntry.confirmRecordDelete'),
          buttons: <>
            <CancelButton onClick={onCancel} />
            <XDivider width='10px' />
            <ContainedButton onClick={() => handleDeleteBoxes(jobId, selectedFiles)} >buttons.yes</ContainedButton>
          </>,
          closeX: true
        })
      }
    }
  }

  const handleDeleteBoxes = async (jobId, selectedFiles) => {
    setBusy()
    selectedFiles.forEach(async (doc, index) => {
      await gdeTransactions.deleteBoxData(jobId, doc.skpBoxId || doc.boxId)
      const jobBoxMetricsData = await gdeTransactions.getMetricsForJobBox(jobId, doc.skpBoxId || doc.boxId)
      jobBoxMetricsData.forEach((doc) => {
        const data = doc.data()
        const { metricsFileId, jobCategory } = data
        if (metricsFileId !== undefined && jobCategory === 'Data Entry User') {
          const metricsData = {
            boxId: 0,
            totalBoxCount: 0,
            totalRecordCount: 0,
            updatedTs: new Date(),
          }
          gdeTransactions.updateMetricsForJobBox(doc.id, metricsData)
        }
      })
    })
    const boxCount = fileList.length - selectedFiles.length
    if (currentUserType?.current !== userTypes.DATAENTRY_AND_VERIFY_USER && currentUserType?.current !== userTypes.DATAENTRY_USER) {
      const data = {
        totalBoxes: boxCount,
      }
      await gdeTransactions.updateJob(jobId, data)
      history.push(`${routePaths.boxList}/${jobId}`)
    } else {
      setTimeout(props.onCancel(null, null, props.currentLockableFields, props.currentLockableFieldsData, dataEntryType), 50000)
    }

    setTimeout(successToast({ message: t('toast.boxDeleteSuccess', { deletedBoxesCount: selectedFiles.length }) }), 50000)
    closeGeneralDialog()
    clearBusy()
  }

  const handleDeleteFiles = async (jobId, boxId, selectedFiles) => {
    setBusy()
    const newFileList = []
    // eslint-disable-next-line
    for (const [key, value] of Object.entries(selectedFiles)) {
      await gdeTransactions.deleteFile(jobId, boxId, value.fileId)
    }

    const filesForBox2 = await gdeTransactions.getFilesForBox(jobId, boxId)

    fileList.forEach(async (doc) => {
      await gdeTransactions.deleteFile(jobId, boxId, doc.fileId)
    })

    const files2 = filesForBox2.docs.sort(function (a, b) {
      return a.id.localeCompare(b.id, undefined, {
        numeric: true,
        sensitivity: 'base'
      })
    })

    const myPromise = new Promise(function (resolve, reject) {
      setTimeout(
        files2.forEach(async (doc, index) => {
          const docData = doc.data()
          const newCounter = index + 1
          const newFileName = newCounter.toString().padStart(5, '0')
          docData.fileInfo.fileId = newFileName
          docData.fileNumber = newFileName
          newFileList[index] = docData.fileInfo
          await gdeTransactions.createFile(jobId, boxId, newFileName, docData)
        })
        , 5000)
      resolve(newFileList)
    })

    const jobBoxMetricsData = await gdeTransactions.getMetricsForJobBox(jobId, boxId)
    jobBoxMetricsData.forEach((doc) => {
      const data = doc.data()
      const { metricsFileId, totalBoxCount, jobCategory } = data
      if (metricsFileId !== undefined && jobCategory === 'Data Entry User') {
        const metricsData = {
          totalRecordCount: newFileList.length,
          updatedTs: new Date(),
        }
        totalBoxCount > 0 && gdeTransactions.updateMetricsForJobBox(doc.id, metricsData)
      }
    })

    myPromise.then(function (newFileList) {
      setTimeout(successToast({ message: t('toast.filesDeleteSuccess', { deletedFilesCount: filesLength }) }), 50000)
      if (props.isFromQC) {
        // history.goBack()
        history.push(`${routePaths.boxQualityCheck}/${jobId}`)
        clearBusy()
      } else {
        if (newFileList.length === 0) {
          indexPointerOfFile = 0
        }
        setTimeout(props.onCloseTable(currentUserType, props.apiRef, jobId, boxId, indexPointerOfFile, true, newFileList, props.currentLockableFields, props.currentLockableFieldsData), 50000)
      }
      setTimeout(closeGeneralDialog(), 50000)
    })
  }

  const rows = fileList

  const columns = columnsList

  const onCancel = () => {
    closeGeneralDialog()
  }

  const onAddNewFile = async (boxId, jobId) => {
    await gdeTransactions.updateBoxStatus(jobId, boxId, constants.boxStatus.dataEntryInProcess)
    history.push(`${routePaths.dataEntry}/${jobId}/${boxId}/AddNewFilesByQC`)
  }
  // eslint-disable-next-line
  function CustomToolbar() {
    return (
      <GridToolbarContainer style={{ flexDirection: 'row-reverse' }}>
        <GridToolbarColumnsButton />
      </GridToolbarContainer>
    )
  }

  return (
    <>
      <LocalToast ref={refLocalToast} />
      {!qualityCheck
        ? <BoxFlex>
          <>
            {isBoxList === 'boxList'
              ? null
              : (currentUserType?.current === userTypes.VERIFICATION_USER || currentUserType?.current === userTypes.DATAENTRY_AND_VERIFY_USER || currentUserType?.current === userTypes.DATAENTRY_USER || currentUserType?.current === undefined) && <BottomPaddedButton id={'dataEntry_button_select_fieldstoupdate'} variant='contained' color='primary' onClick={() => { handleDeleteModal(props.jobId, props.boxId, selectedFiles) }} disabled={enable}>
                buttons.selectFilesToDelete
              </BottomPaddedButton>}
            <XDivider width="20px" />
            {isBoxList === 'boxList' || (isBoxList === 'dataEntry' && (currentTemplateType === 'New Box' || currentTemplateType === 'Maintenance Box'))
              ? null
              : <BottomPaddedButton id={'dataEntry_button_select_fieldstoupdate'} variant='contained' color='primary' onClick={() => { handleModal(props.boxId, props.acc2, props.acc3, props.arrRefs, props.buttonRef, selectedFiles, props.jobId) }} disabled={enable}>
                buttons.selectFieldsToUpdate
              </BottomPaddedButton>}
            {props.isFromQC &&
              <>
                <XDivider width="20px" />
                <BottomPaddedButton id={'dataEntry_button_addNewFile'} variant="contained" color="primary" onClick={() => { onAddNewFile(props.boxId, props.jobId) }} >dataEntry.addEditFile
                </BottomPaddedButton>
                <XDivider width="20px" />
              </>}
          </>
        </BoxFlex>
        : null}
      <YDivider height='30px' />
      <TableContainer>
        <DivCenter style={{ height: 500, width: '100%' }}>
          <DataGrid
            rows={rows}
            apiRef={props.apiRef}
            columns={columns}
            onRowSelectionModelChange={onSelectionChange}
            initialState={{
              pagination: { paginationModel: { pageSize: 20 } },
            }}
            pageSizeOptions={[20, 50, 100]}
            checkboxSelection={!isViewAllFiles}
            disableRowSelectionOnClick
            disableColumnMenu
            slots={{
              toolbar: CustomToolbar,
            }}
            getRowHeight ={() => 'auto'}
          />
        </DivCenter>
      </TableContainer>
    </>
  )
}

DatGridTable.propTypes = {
  apiRef: PropTypes.any,
  indexPointerOfFile: PropTypes.any,
  fileList: PropTypes.array,
  columnsList: PropTypes.array,
  boxId: PropTypes.string,
  acc2: PropTypes.string,
  acc3: PropTypes.array,
  arrRefs: PropTypes.array,
  buttonRef: PropTypes.array,
  jobId: PropTypes.string,
  statusTobeUpdated: PropTypes.any,
  currentLockableFields: PropTypes.any,
  currentLockableFieldsData: PropTypes.any,
  onCloseTable: PropTypes.func,
  onCancel: PropTypes.func,
  isFromQC: PropTypes.bool,
  isViewAllFiles: PropTypes.string,
  currentUserType: PropTypes.string,
  qualityCheck: PropTypes.bool,
  currentTemplateType: PropTypes.any,
}

export default DatGridTable